"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _helpers = require("./helpers");
var _RichTextPropTypes = require("./RichTextPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RichTextHeading = _ref => {
  var {
    heading = 'h1',
    inverse = false,
    align = 'auto',
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
    block: true,
    variant: {
      size: heading,
      inverse: inverse
    },
    align: align,
    heading: heading
  }, _react.default.Children.map(children, child => {
    if (!child) return null;

    // Inherit header size to child components
    return (0, _helpers.cloneElementOfType)(child, {
      size: heading
    });
  }));
};
RichTextHeading.propTypes = {
  heading: _propTypes.default.oneOf(_RichTextPropTypes.headingSizes).isRequired,
  children: _propTypes.default.node,
  inverse: _propTypes.default.bool,
  align: _propTypes.default.oneOf(_RichTextPropTypes.alignOptions)
};
var _default = exports.default = RichTextHeading;